import React, { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState(() => {
    // Récupère l'utilisateur ID depuis le localStorage au montage initial
    return localStorage.getItem('userId');
  });

useEffect(() => {
  console.log('Current userId:', userId, 'Type:', typeof userId);

  if (userId !== null && userId !== undefined && userId !== '') {
    localStorage.setItem('userId', userId);
    console.log('Saving userId to localStorage:', userId);
  } else {
    localStorage.removeItem('userId');
    console.log('Clearing userId from localStorage');
  }
}, [userId]);


  return (
    <UserContext.Provider value={{ userId, setUserId }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
